<template>
  <v-card>
    <v-card-text class="no-padding">
      <div v-if="showCamera">
        <!----     2: INSTRUCTIONS + WEBCAM     ---->
        <div
          v-show="!capturedImage"
          class="webcam-section"
        >
          <v-carousel
            v-model="switchInstructionsOrWebcam"
            :cycle="false"
            :continuous="false"
            hide-delimiter-background
            height="100%"
          >
            <v-carousel-item light>
              <!--v-sheet  color="white" height="100%"-->
              <v-row
                class="fill-height no-margin"
                align="center"
                justify="center"
              >
                <div class="instructions">
                  <h3>{{ $t('signature.sign.advanced.photo.photo') }} {{ imageLabelsIndex+1 }} <small>{{ $t('commons.of') }}</small> {{ imageLabels.length }} - {{ getLocalizedLabel(currentImageLabel) }}</h3>
                  <p v-if="instructionsForCurrentLabel" v-html="instructionsForCurrentLabel.body" />
                  <img v-if="instructionsForCurrentLabel"
                    :src="instructionsForCurrentLabel.image"
                    :alt="currentImageLabel"
                  >
                </div>
              </v-row>
              <!--/v-sheet-->
            </v-carousel-item>
            <v-carousel-item light>
              <v-sheet
                color="white"
                height="100%"
                tile
              >
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center"
                >
                  <div class="webcam-square">
                    <WebCam
                      :qrcode-url="currentUrl"
                      @capture="captureImage"
                      @error="getError"
                    />
                  </div>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </div>

        <!----     3: CONFIRMATION     ---->
        <div
          v-if="capturedImage"
          class="webcam-section"
        >
          <div
            class="captured-confirmation-section"
          >
            <h3>{{ $t('signature.sign.advanced.photo.ask_confirmation') }} "{{ getLocalizedLabel(capturedImage.label) }}" ?</h3>
            <div class="captured-confirmation-action-bar">
              <v-btn
                color="primary"
                :loading="submitting"
                @click="confirmCapturedImage"
              >
                {{ $t('commons.say_yes') }}
              </v-btn>
              <v-btn @click="discardCapturedImage">
                No
              </v-btn>
            </div>
          </div>
          <div class="webcam-square">
            <img
              :src="capturedImage.src"
              class="captured-image"
            >
          </div>
        </div>
      </div>
      <!----     1: INFORMATIONS     ---->
      <div
        v-else
        class="starting"
      >
        <div class="text-container">
          <h2>{{ $t('signature.sign.advanced.photo.title') }}</h2>
          <h3>{{ $t('signature.sign.advanced.photo.description', {first_name: recipient.first_name}) }}</h3>
          <h3><small><v-icon>mdi-shield-account-outline</v-icon> {{ $t('signature.sign.advanced.photo.privacy') }}</small></h3>
        </div>
        <v-btn
          color="primary"
          @click="showCamera = true"
        >
          {{ $t('signature.sign.advanced.photo.activate_camera') }}
        </v-btn>
      </div>

      <div v-if="errorMessage">
        <p class="error-message">
          {{ errorMessage }}
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

import WebCam from './../../webcam/WebCam.vue'

import { mapState } from 'vuex'


export default {
  name: 'CheckinDataPhoto',

  components: {
    WebCam,
    Confirm: () => import('../../base/Confirm'),
  },

  props: {
    recipient: {
      type: Object,
      required: true,
    },
    order_id: {
      type: Number,
      required: true
    },
    reservation_id: {
      type: Number,
      required: true
    },
    index_photo: {
      type: Number,
      required: false
    },
  },

  data () {
    return {
      showCamera: false,
      errorMessage: null,
      capturedImage: null,
      capturedImages: [],
      previousImages: [],
      serverUpdated: false,
      switchInstructionsOrWebcam: 0,
      // currentLabel: this.imageLabels[0]
    }
  },

  computed: {
    ...mapState('layout', ['submitting']),
    reportPresence () {
      var toReturn = true
      if (this.recipient.audit_reports) {
        toReturn = Object.keys(this.recipient.audit_reports).length > 0 ? true : false
      }
      if (this.capturedImages.length > 0) {
        toReturn = false
      }
      return toReturn
    },
    imageLabels () {
      let labels = ['face_document_image', 'front_document_image', 'back_document_image']
      return (this.index_photo || this.index_photo === 0) ? [labels[this.index_photo]] : labels
    },
    capturedImageLabels () {
      return this.capturedImages.map(imageObj => imageObj.label)
    },
    imageLabelsIndex () {
      return this.imageLabels.length - (this.imageLabels.length - this.capturedImageLabels.length)
    },
    currentImageLabel () {
      return this.imageLabels[this.imageLabelsIndex]
    },
    areAllImagesCaptured () {
      return this.capturedImageLabels.length == this.imageLabels.length || this.previousImages.length == this.imageLabels.length
    },
    // allPresentImages() {
    //   return [...this.previousImages, ...this.capturedImages]
    // },
    // Verifica che le foto siano state scattate
    areAllImagesValid () {
      return this.areAllImagesCaptured
    },
    instructionsForCurrentLabel () {
      return this.instructions.find(instruction => instruction.label == this.currentImageLabel)
    },
    instructions () {
      return [
        { label: 'face_document_image', image: require('../../../assets/images/face_document_image.jpg'), body: this.$t('signature.sign.advanced.photo.hints.face_document_image') },
        { label: 'front_document_image', image: require('../../../assets/images/front_document_image.png'), body: this.$t('signature.sign.advanced.photo.hints.front_document_image') },
        { label: 'back_document_image', image: require('../../../assets/images/back_document_image.png'), body: this.$t('signature.sign.advanced.photo.hints.back_document_image') },
      ]
    },
    currentUrl () {
      return window.location.toString()
    },
  },

  created () {
    ['face_document_image', 'front_document_image', 'back_document_image'].forEach(label => {
      if (this.recipient[`${label}_url`]) this.previousImages.push({ label, src: this.recipient[`${label}_url`] })
    })
  },

  methods: {
    captureImage (image) {
      // this.capturedImages.push({ src: image, label: Math.random().toString(36).substring(7) })
      this.capturedImage = { src: image, label: this.currentImageLabel}
      // Move carousel to the first slide with instructions about current step
      this.switchInstructionsOrWebcam = 0
    },
    confirmCapturedImage () {
      this.capturedImages.push(this.capturedImage)
      this.updateRecipient(this.capturedImage)
        .then(_ => {
          this.capturedImage = null
          this.serverUpdated = true
        })
    },
    discardCapturedImage () {
      this.capturedImage = null
    },
    getError (label) {
      this.errorMessage = label ? this.$t(`signature.sign.errors.${label}`) : this.$t('alerts.generic_error')
    },
    getLocalizedLabel (label) {
      return this.$t(`recipient.${label}`)
    },
    updateRecipient (capturedImage) {
      const attributes = {
        [capturedImage.label]: capturedImage.src,
        label: capturedImage.label,
        single_photo: this.index_photo,
        guest_name: (this.recipient.last_name + " " + this.recipient.first_name ).toLowerCase(),
        guest_key: (this.recipient.id)
      }
      const _this = this
      return this.$store.dispatch(`order/updateRecognitionPhoto`, {
        orderId: this.order_id,
        reservationId: this.reservation_id,
        attributes,
      }).then(result => {
        _this.$emit('update-url-photo', result.guest_state, result.info_image, _this.recipient.id)
        if (result.last_image){
          _this.$emit('update-start-processing', result.last_image, _this.recipient.id)
        }
      }).catch(error => {
          this.serverSideErrors = error.body ? error.body.errors : {}
          if (!error.status) {
            this.$store.dispatch('layout/replaceAlert', {
              type: 'error',
              resource: 'recipient',
              fields: this.serverSideErrors,
            })
          }
        })
    }
  },
}
</script>

<style lang="scss" scoped>
  .starting {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow-y: scroll;
    align-items: center;
    height: 20rem;
    padding: 15px;
    .text-container{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 15px 0;
      h2 {
        text-align: center;
      }
      h3 {
        margin: 5px 0;
      }
    }
  }
  @media (max-width: 768px) {
    .starting{
      flex-direction: column-reverse;
    }
  }

  .instruction{
    padding: 20px;
  }

  .webcam-section {
    //display: flex;
    //flex-direction: column;
    //justify-content: flex-start;
    //align-items: center;
    display: grid;
    place-items: center;
    .captured-confirmation-section {
      margin-top: 1rem;
      margin-bottom: 0.2rem;
      .captured-confirmation-action-bar {
        margin-bottom: 0.2rem;
        display: flex;
        justify-content: space-evenly;
      }
    }
  }

  .webcam-square {
    display: flex;
    padding: 1px;
    border-radius: 3rem;
    margin: 1rem;
    background-color: #000;
    overflow: hidden;
  }
  #camera-container{
    border-radius: 3rem;
    overflow: hidden;
  }

  .captured-image {
    width: 100%;
    height: 100%;
  }

  .captured-images {
    //It is no longer needed now that we removed the end message above
    //margin-top: 5rem;
    .captured-image-box {
      width: 16rem;
      background: linear-gradient(to right top, #eeeeee, #efefef);
      border-radius: 0.5rem;
      padding: 0.4rem;
      .captured-image-thumb {
        width: 100%;
        border-radius: 0.5rem;
      }
      &.error {
        color: #8a1f11;
        border-left: solid red 2px;
      }
    }
  }

  .error-message {
    text-align: center;
    color: #8a1f11;
    font-size: 1.2em;
  }

  .instructions {
    margin: 1rem;
    img {
      width: 100%;
    }
  }

  .no-padding {
    padding: 0;
  }

  .no-margin {
    margin: 0;
  }

  .grid-center {
    height: 100%;
    width: 100%;
    display: grid;
    place-items: center;
  }

  small {
    color: gray;
  }
</style>
